import type { EPlatform } from '@/utils/enums/platform-enum';

export interface StyleHotProductViewState {
  activeTabIndex: number;
  pageScrollY: number | null;
  stickyTabsVisible: boolean;
  stickyTabsScrollLeft: number;
  stickyTabsOrderStartIndex: number;
  selectedColorByProductKey: Record<string, number>;
}

interface BuildStyleHotProductViewStateKeyParams {
  marketingPageId?: number;
  isPreview: boolean;
  adp?: string;
  deviceType: EPlatform;
}

interface RegisterPageReturnScrollRestoreParams {
  pageUrl: string;
  scrollY: number;
  onRestored: () => void;
}

export function buildStyleHotProductViewStateKey({
  marketingPageId,
  isPreview,
  adp,
  deviceType,
}: BuildStyleHotProductViewStateKeyParams) {
  return [
    'local',
    'ui',
    'styleHotProduct',
    {
      marketingPageId: marketingPageId || 0,
      isPreview,
      adp: adp || '',
      deviceType,
    },
  ] as const;
}

export function createStyleHotProductViewState(activeTabIndex: number): StyleHotProductViewState {
  return {
    activeTabIndex,
    pageScrollY: null,
    stickyTabsVisible: false,
    stickyTabsScrollLeft: 0,
    stickyTabsOrderStartIndex: activeTabIndex,
    selectedColorByProductKey: {},
  };
}

export function getStyleHotProductColorStateKey(product: {
  id?: number | string;
  shop_sku?: string;
}): string {
  return String(product.id || product.shop_sku || '');
}

export function registerStyleHotProductPageReturnScrollRestore({
  pageUrl,
  scrollY,
  onRestored,
}: RegisterPageReturnScrollRestoreParams) {
  const handlePageReturn = () => {
    window.removeEventListener('popstate', handlePageReturn);
    window.removeEventListener('pageshow', handlePageReturn);

    if (`${window.location.pathname}${window.location.search}` !== pageUrl) {
      onRestored();
      return;
    }

    const restoreScroll = () => window.scrollTo({ top: scrollY, left: 0, behavior: 'auto' });

    restoreScroll();
    window.requestAnimationFrame(() => {
      restoreScroll();
      window.requestAnimationFrame(() => {
        restoreScroll();
        onRestored();
      });
    });
  };

  window.addEventListener('popstate', handlePageReturn);
  window.addEventListener('pageshow', handlePageReturn);
}
